import type { FaceCaptureStepValues } from '@/steps/face/constants';

import { Processing } from '@/components/Processing/Processing';
import { FaceCaptureStep } from '@/steps/face/constants';
import * as GSC from '@/styles/GlobalStyles';

export type FaceInfoOverlayProps = {
  captureStep: FaceCaptureStepValues;
  image: Blob | null;
};

export const FaceInfoOverlay = ({ captureStep, image }: FaceInfoOverlayProps) => {
  if (captureStep === FaceCaptureStep.PROCESSING) {
    return (
      <GSC.FadeInContainer>
        <Processing capturedImage={image} />
      </GSC.FadeInContainer>
    );
  }

  return null;
};
